import AddDatasetPage from "../components/AddDatasetPage"

function AddPage() {
    return <div className="">
        <AddDatasetPage />
    </div>
}

export default AddPage;